import axios from './apiAdapter'


export const fetchAllEnums = async () =>
    axios.get(`/enum`)